const date = {
  dateFormatted (date) {
    let currentDate = new Date(date)
    let day = String(currentDate.getDate()).padStart(2, '0')
    let month = String(currentDate.getMonth() + 1).padStart(2, '0')
    let year = currentDate.getFullYear()
    return year + '-' + month + '-' + day
  }
}
export default date
